import React, { useEffect, useState } from 'react';
import Login from '../Login/Login';
import './Auth.css';
import defaultLogo from '../../../images/logo.png'
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../../url';
import { guardarSiteConfig, obtenerLogoGuardado } from '../../siteConfig';

export default function Auth() {
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);
    const [storeStatusMessage, setStoreStatusMessage] = useState('');
    const [storeStatusCode, setStoreStatusCode] = useState('active');

    useEffect(() => {
        const cargarLogo = async () => {
            try {
                const response = await fetch(`${baseURL}/configGet.php`);
                const data = await response.json();

                if (data.config) {
                    guardarSiteConfig(data.config);
                }

                if (data.config?.logo) {
                    setAppLogo(data.config.logo);
                }
                if (data.config?.storeStatusMessage) {
                    setStoreStatusMessage(data.config.storeStatusMessage);
                }
                if (data.config?.storeStatus) {
                    setStoreStatusCode(data.config.storeStatus);
                }
            } catch (error) {
                console.error('Error al cargar el logo del acceso:', error);
            }
        };

        cargarLogo();
    }, []);

    return (
        <div className='AuthContainer'>
            <Anchor to={`/`} >
                <img src={appLogo} alt="Logo de la tienda" className='logoAtuh' />
            </Anchor>

            {storeStatusCode !== 'active' && storeStatusMessage && (
                <div className={`storeAccessCard ${storeStatusCode === 'suspended' ? 'isSuspended' : ''}`}>
                    <span className='storeAccessEyebrow'>{storeStatusCode === 'suspended' ? 'Tienda pausada' : 'Aviso de suscripción'}</span>
                    <p>{storeStatusMessage}</p>
                </div>
            )}

            <Login />


        </div>
    );
}
